const state = {
    journalentryline: [],
    id: [],
    loading: false
};

export default state;